import { ActivityConnectionsEvent } from "PFCore/types";

export const getTagRelatedEventDiff = (entry: ActivityConnectionsEvent) => {
  const isTagRelatedEvent = !!entry.metadata.activityTag;

  if (!isTagRelatedEvent) {
    return entry.diff;
  }

  const tagDiff = (entry.metadata?.activityTag ?? []).map((tag) => tag ?? "");

  return entry.diff.map((entryDiff) => {
    const updatedDiff = {
      ...entryDiff,
      diff: {
        ...entryDiff.diff,
        activity_tag: tagDiff
      }
    };

    return updatedDiff;
  });
};
